<template>
    <!-- <div id="content" ref="pdfContent" style="display: none">
        <h1>Modelo de Contenido</h1>
        <p>Este es un ejemplo de contenido para el PDF.</p>
    </div> -->
    <div class="hola" ref="pdfContent">
        <h1>{{ title }}</h1>
        <p>{{ description }}</p>
    </div>
    <div>
        <p>pruebaaa</p>
    </div>
</template>

<script>
// Este componente solo sirve como contenedor para el contenido del PDF
/*defineProps({
    title: String,
    description: String,
});*/
export default {
    name: "TestTempComponent", // Usa un nombre multi-palabra
    props: {
        title: String,
        description: String,
    },
};
</script>

<style setup>
.hola {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f5f5f5;
}
</style>
